export enum CompanyType {
  NORMAL = 'NORMAL',
  SERVICE = 'SERVICE',
  ACCOUNTING = 'ACCOUNTING',
}

/**
 * A service company has no tachograph database of its own, so every
 * /api/{companyId}/… call for it fails with 500 "No database found".
 * A company promoted to SERVICE by a global admin can still have one, hence
 * the conjunction rather than a plain type check.
 */
export const isUnusableServiceCompany = (
  company?: { type?: CompanyType; hasDatabase?: boolean } | null,
) => company?.type === CompanyType.SERVICE && company?.hasDatabase === false

export const isServiceCompany = (company?: { type?: CompanyType } | null) =>
  company?.type === CompanyType.SERVICE

/** Child company billed umbrella-style through its service account (konto usługowe). */
export const isUnderServiceAccount = (
  company?: { tenant?: { type?: CompanyType } | null } | null,
) => company?.tenant?.type === CompanyType.SERVICE
